module.exports = __webpack_public_path__ + "img/guide4.db2d229d.png";